// extracted by mini-css-extract-plugin
module.exports = {"text":"Icons_text__fzS9e","item":"Icons_item__VX4x4","button":"Icons_button__ms01C","link":"Icons_link__JT7JO","icon":"Icons_icon__rdhbo"};